import { Component, EventEmitter, Input, Output } from '@angular/core';

import { OrgSelectorService } from '../../core/services/org-selector.service';

import { MenuItem } from './models/menu-item.model';

@Component({
	selector: 'app-menu',
	styleUrls: ['./menu.component.scss'],
	templateUrl: './menu.component.html',
})
export class MenuComponent {
	@Output() closeEvt: EventEmitter<void> = new EventEmitter();

	@Input() menu: MenuItem[] = [];
	@Output() navigate: EventEmitter<string> = new EventEmitter();
	activeIdx: number = -1;

	hoverIdx: number = -1;
	outCount: number = 0;

	constructor(private readonly orgSelection: OrgSelectorService) {}

	get orgsCount(): number {
		return this.orgSelection.organizationsNames.size;
	}

	onMenuItemClick(index: number): void {
		if (index === -1) {
			this.navigate.emit('inicio');
		} else {
			if (!this.menu[index]!.subItems) {
				this.navigate.emit(this.menu[index].path);
				this.closeEvt.emit();
			} else {
				if (this.activeIdx === index) {
					this.activeIdx = -1;
				} else {
					this.activeIdx = index;
				}
			}
		}
	}

	onMoveOut(): void {
		this.outCount++;
		if (this.outCount > 0) {
			this.hoverIdx = -1;
		}
	}

	onSubmenuItemClick(index: number, indexSub: number): void {
		if (this.menu[index].subItems) {
			const path = this.menu[index]!.subItems![indexSub]!.path!;
			this.navigate.emit(path);
			this.closeEvt.emit();
		}
	}
}
